export default "__VITE_ASSET__MBNSmuOd__"